export default "__VITE_ASSET__4c924583__"